<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-col>
        <TaskDialog
            :show-dialog="task_dialog.show"
            :task-id="task_dialog.task_id"
            :client-id="0"
            :is-template="true"
            :is-job-template="object_type === 'job'"
            :is-workflow-template="object_type === 'workflow'"
            :template-type="object_type"
            :is-temporary-client-task="true"
            :temporary-client-task="task_dialog.task"
            :available-related-tasks="task_dialog.availableRelatedTasks"
            :pseudo-users="pseudoUsers"
            :is-cp-template="isClientPortal"
            @delete="removeDeletedTask"
            @save="save_task"
            @close="close_task_dialog"
        ></TaskDialog>
        <ClientPlanReviewChildrenDialog
            v-if="review_dialog.show"
            :show-dialog="review_dialog.show"
            :projects="review_dialog.projects"
            :company-id="account_id"
            @confirm="save_plan_confirmed"
            @close_modal="close_review_dialog"
        />

        <v-row>
            <v-col
                v-if="object_type === 'job' || object_type === 'workflow'"
                class="col-lg-8 col-md-7 col-sm-4 col-12"
                style="margin-top: -20px;"
            >
                <v-row>
                    <v-col :cols="isClientPortal ? 8 : 12">
                        <v-text-field
                            v-if="object_type === 'job' || object_type === 'workflow'"
                            v-model="form_data.name"
                            class="header-title title"
                            outlined
                            :label="object_type === 'job' ? $t('Job name') : $t('Workflow name')"
                            :hide-details="!form_data.name_error"
                            :error-messages="form_data.name_error"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="4" v-if="isClientPortal">
                        <v-select
                            v-model="form_data.locale_code"
                            :items="ui_languages"
                            :item-text="(item) => formatLanguageLabel(item)"
                            item-value="code"
                            :label="$t('Language')"
                            outlined
                        />
                    </v-col>
                </v-row>
            </v-col>
            <v-col v-else class="col-lg-8 col-md-7 col-sm-4 col-12 pt-4">
                <div class="headline" v-html="page_title"></div> <!-- WARNING! THIS CAN BE ARBITRARY! -->
                <div v-if="object_type === 'project' && page_title">
                    <v-btn class="mr-2 help-link px-0" color="n4" text @click="toggleSideBar(true)">
                        {{ $t("Details") }}
                        <v-icon right size="18" class="ml-0">mdi-menu-right</v-icon>
                    </v-btn>
                </div>
            </v-col>
            <v-col class="col-lg-4 col-md-5 col-sm-8 col-12 text-right pt-4">
                <v-btn
                    v-if="help_link"
                    class="mr-2 help-link"
                    text
                    color="primary"
                    @click="open_help(help_link)"
                >
                    <v-icon left size="18">mdi-help-circle</v-icon>
                    <span>{{ $t("Learn more") }}</span>
                </v-btn>
                <v-btn class="mr-2" text color="primary" @click="() => add_task()">
                    <v-icon size="24" left>mdi-plus-box</v-icon>
                    <span>{{ $t("Add task") }}</span>
                </v-btn>
            </v-col>
        </v-row>

        <v-row>
            <v-col class="col-3">
                <v-row>
                    <v-col>
                        <v-select
                            v-model="form_data.job_source"
                            outlined
                            class="pt-0"
                            hide-details
                            :menu-props="{ offsetY: true, auto: true }"
                            :items="form_data.job_sources"
                            item-text="title"
                            item-value="name"
                            @change="job_source_changed"
                        ></v-select>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-card>
                            <v-card-text class="pt-0 px-0 pb-2">
                                <v-text-field
                                    v-model="job_search"
                                    hide-details
                                    dense
                                    class="search-jobs mb-2 mt-0"
                                    :placeholder="$t('Search')"
                                    append-icon="search"
                                ></v-text-field>

                                <template v-if="form_data.job_source === 'jobs' || form_data.job_source === 'workflows'">
                                    <v-list class="py-0">
                                        <template v-for="(job, index) in jobs">
                                            <v-subheader
                                                v-if="job.type === 'sub-header'"
                                                :key="index"
                                                class="subtitle-2"
                                            >
                                                {{ job.title }}
                                            </v-subheader>
                                            <v-list-item
                                                v-else
                                                :key="index"
                                                :style="{
                                                    backgroundColor: form_data.highlighted_job_id === job.id
                                                        ? '#FFF3E0'
                                                        : '#FFFFFF'
                                                }"
                                                @click="job_select($event, job)"
                                            >
                                                <v-list-item-action class="mr-3">
                                                    <v-checkbox
                                                        v-model="job.selected"
                                                        color="primary"
                                                        @change="job_change($event, job)"
                                                    ></v-checkbox>
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        {{ job.name }} ({{
                                                            job.task_count
                                                                | format_number
                                                        }})
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                    </v-list>
                                </template>

                                <template v-if="form_data.job_source === 'clients' || form_data.job_source === 'projects'">
                                    <v-list class="py-0">
                                        <v-list-item
                                            v-for="client in template_clients"
                                            :key="client.id"
                                            :style="{
                                                backgroundColor: form_data.highlighted_job_id === client.id
                                                    ? '#FFF3E0'
                                                    : '#FFFFFF'
                                            }"
                                            @click="template_client_select($event, client)"
                                        >
                                            <v-list-item-action class="mr-3">
                                                <v-checkbox
                                                    v-model="client.selected"
                                                    color="primary"
                                                    @change="template_object_change($event, client)"
                                                ></v-checkbox>
                                            </v-list-item-action>
                                            <v-list-item-content>
                                                <v-list-item-title>
                                                    {{
                                                        client.name
                                                    }}
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list>
                                    <v-row v-if="total_pages > 1">
                                        <v-col class="text-center">
                                            <span class="mr-2">{{
                                                page_info
                                            }}</span>
                                            <v-btn
                                                text
                                                icon
                                                :disabled="current_page <= 1"
                                                @click="
                                                    set_page(current_page - 1)
                                                "
                                            >
                                                <v-icon>
                                                    mdi-chevron-left
                                                </v-icon>
                                            </v-btn>
                                            <v-btn
                                                text
                                                icon
                                                :disabled="
                                                    current_page >= total_pages
                                                "
                                                @click="
                                                    set_page(current_page + 1)
                                                "
                                            >
                                                <v-icon>
                                                    mdi-chevron-right
                                                </v-icon>
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </template>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
            <template v-if="task_templates_loaded && jobs_templates_loaded">
                <v-col
                    v-if="task_groups.length === 0"
                    class="col-9 plan-select-jobs"
                >
                    <template v-if="object_type === 'client'">
                        <v-row>
                            <div class="arrow">
                                <svg
                                    width="200"
                                    height="42"
                                    viewBox="0 0 250 52"
                                >
                                    <path
                                        d="M 4 38 A 200 350 120 0 1 247 31"
                                        stroke="#f37100"
                                        fill="none"
                                        stroke-width="2.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    ></path>
                                    <path
                                        d="M 19 3 L 5 35 A 5 5 0 0 0 8 41 L 40 50"
                                        stroke="#f37100"
                                        stroke-width="2.5"
                                        fill="none"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    ></path>
                                </svg>
                            </div>
                            <v-col class="text-center display-2">
                                <span v-if="form_data.job_source === 'jobs'">{{
                                    $t("Select jobs")
                                }}</span>
                                <span
                                    v-else
                                >{{ $t("Select task plan") }}<br /><span
                                    class="headline"
                                >{{ $t("of existing client") }}</span></span>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col class="text-center subtitle-1">
                                {{ $t("You can also choose") }}
                                <a
                                    v-if="form_data.job_source === 'jobs'"
                                    href="javascript:"
                                    class="inner-text-link"
                                    @click="change_source('clients')"
                                >{{ $t("existing client tasks plan") }}</a>
                                <a
                                    v-else
                                    href="javascript:"
                                    class="inner-text-link"
                                    @click="change_source('jobs')"
                                >{{ $t("existing predefined jobs") }}</a>
                                <br />
                                {{ $t("or") }}
                                <a
                                    href="javascript:"
                                    class="inner-text-link"
                                    @click="goto_client_plan"
                                >{{ $t("create a new plan") }}</a>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col class="text-center">
                                <v-btn
                                    text
                                    color="primary"
                                    @click="close"
                                >
                                    {{ cancel_button_text }}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </template>
                    <template v-if="object_type === 'project'">
                        <v-row>
                            <div class="arrow">
                                <svg
                                    width="200"
                                    height="42"
                                    viewBox="0 0 250 52"
                                >
                                    <path
                                        d="M 4 38 A 200 350 120 0 1 247 31"
                                        stroke="#f37100"
                                        fill="none"
                                        stroke-width="2.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    ></path>
                                    <path
                                        d="M 19 3 L 5 35 A 5 5 0 0 0 8 41 L 40 50"
                                        stroke="#f37100"
                                        stroke-width="2.5"
                                        fill="none"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    ></path>
                                </svg>
                            </div>
                            <v-col class="text-center display-2">
                                <span>
                                    {{ $t("Select workflow") }}
                                </span>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col class="text-center subtitle-1">
                                {{ $t("You can also choose") }}
                                <a
                                    v-if="form_data.job_source === 'workflows'"
                                    href="javascript:"
                                    class="inner-text-link"
                                    @click="change_source('projects')"
                                >{{ $t("existing project workflow") }}</a>
                                <a
                                    v-else
                                    href="javascript:"
                                    class="inner-text-link"
                                    @click="change_source('workflows')"
                                >{{ $t("existing workflow") }}</a>
                                <br />
                                {{ $t("or") }}
                                {{ $t("create a new workflow") }}
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col class="text-center">
                                <v-btn
                                    text
                                    color="primary"
                                    @click="close"
                                >
                                    {{ cancel_button_text }}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </template>
                    <template v-else-if="object_type === 'job'">
                        <v-row>
                            <v-col class="text-center display-2">
                                <span>{{ $t("New tasks template") }}</span>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col class="text-center subtitle-1">
                                <a
                                    href="javascript:"
                                    class="inner-text-link"
                                    @click="add_task()"
                                >
                                    {{ $t("Add task") }}
                                </a>
                                {{ $t("to save template!") }}
                            </v-col>
                        </v-row>
                        <v-row v-if="!isClientPortal">
                            <v-col class="text-center subtitle-1">
                                {{ $t("You can also add tasks from jobs")
                                }}<br />
                                {{ $t("or choose") }}
                                <a
                                    href="javascript:"
                                    class="inner-text-link"
                                    @click="change_source('clients')"
                                >
                                    {{ $t("existing client tasks plan") }}
                                </a>
                            </v-col>
                        </v-row>
                    </template>
                    <template v-else-if="object_type === 'workflow'">
                        <v-row>
                            <v-col class="text-center display-2">
                                <span>{{ $t("New workflow template") }}</span>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col class="text-center subtitle-1">
                                <a
                                    href="javascript:"
                                    class="inner-text-link"
                                    @click="add_task()"
                                >
                                    {{ $t("Add task") }}
                                </a>
                                {{ $t("to save template!") }}
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col class="text-center subtitle-1">
                                {{ $t("You can also add tasks from existing workflow templates")
                                }}<br />
                                {{ $t("or choose") }}
                                <a
                                    href="javascript:"
                                    class="inner-text-link"
                                    @click="change_source('projects')"
                                >
                                    {{ isEventTypeCompany(account_id) ? $t("existing event workflow") : $t("existing project workflow") }}
                                </a>
                            </v-col>
                        </v-row>
                    </template>
                </v-col>
                <v-col v-else class="col-9" style="position: relative;">
                    <v-row>
                        <v-col
                            class="px-3 pt-3 pb-0 col-12"
                            style="height: 52px;"
                        >
                            <div
                                style="width: 48px; float: left;"
                                class="pl-2 pr-0"
                            >
                                <v-switch
                                    v-model="all_checked"
                                    hide-details
                                    class="mt-2 pt-0 mb-1"
                                    color="primary"
                                ></v-switch>
                            </div>
                            <div
                                style="float: left;"
                                class="pl-3 pt-1 title"
                            >
                                {{ selected_count | format_number }}
                                {{ $t("tasks selected") }}
                            </div>
                            <div
                                style="float: left;"
                                class="pl-4 pt-1"
                            >
                                <v-btn
                                    class="mr-2"
                                    text
                                    color="primary"
                                    style="text-transform: none;"
                                    @click="show_hide_others"
                                >
                                    {{
                                        show_all
                                            ? $t("Hide others")
                                            : $t("Show all")
                                    }}
                                </v-btn>
                            </div>
                        </v-col>
                    </v-row>

                    <div style="position:relative;" ref="relativeDependencyArrows">
                        <v-row v-for="task_group in task_groups" :key="task_group.name">
                            <v-col
                                v-if="task_group.contains_checked_tasks || show_all"
                                :class=" show_all ? 'tasks-show-all' : 'tasks-show-checked'"
                            >
                                <div class="caption">{{ task_group.title }}</div>
                                <div style="position: relative">
                                    <v-data-table
                                        class="elevation-2 medium-dense-table"
                                        :headers="form_data.headers"
                                        :items="tasks[task_group.name]"
                                        :footer-props="form_data.footer_props"
                                        :hide-default-footer="form_data.tableactions"
                                        :hide-default-header="form_data.tableheaders"
                                    >
                                        <template v-slot:item="{ item }">
                                            <tr
                                                :id="'tbl-row-' + item.id"
                                                :class="[
                                                    form_data.highlighted_job_id === item.job_id
                                                        ? 'task-row highlighted'
                                                        : 'task-row',
                                                    item.selected ? 'task-checked' : 'task-not-checked'
                                                ]"
                                                @mouseenter="rowMouseOver(item.id, true)"
                                                @mouseleave="rowMouseOver(item.id, false)"
                                            >
                                                <td class="pl-2 pr-0 select-col">
                                                    <v-switch
                                                        v-model="item.selected"
                                                        hide-details
                                                        class="mt-1 pt-0 mb-1"
                                                        :color="item.id.toString().includes('tmp') ? 'primary' : 'tretiary'"
                                                        @change="task_change($event, item)"
                                                    ></v-switch>
                                                </td>
                                                <td class="text-left px-1" @click="edit_task(item)">
                                                    <span
                                                        :class="[
                                                            'font-weight-medium',
                                                            'text-truncate',
                                                            'mr-3'
                                                        ]"
                                                        :style="{
                                                            maxWidth: $vuetify.breakpoint.lgAndUp ? '300px;' : '150px;',
                                                            cursor: 'pointer'
                                                        }"
                                                    >
                                                        {{ item.title }}<!-- ({{ item.id }}) -->
                                                    </span>
                                                    <v-chip
                                                        v-if="item.topic_id"
                                                        class="mx-1 grey lighten-3"
                                                        small
                                                        style="vertical-align: baseline;"
                                                    >
                                                        <span class="font-weight-medium grey--text text--darken-1">
                                                            {{
                                                                get_topic_name(
                                                                    item.topic_id
                                                                )
                                                            }}
                                                        </span>
                                                    </v-chip>
                                                    <v-chip
                                                        v-if="item.depends_on.length > 0"
                                                        class="mx-1 grey lighten-3"
                                                        small
                                                        style="vertical-align: baseline;"
                                                    >
                                                        <v-icon small color="grey darken-2" class="mr-1">
                                                            mdi-arrange-bring-to-front
                                                        </v-icon>
                                                        <span class="font-weight-medium grey--text text--darken-1">
                                                            <span v-if="item.depends_on.length === 1">
                                                                {{ getTaskTitle(item.depends_on[0]) | max_len(25) }}
                                                            </span>
                                                            <span v-else>
                                                                {{ $t("{0} dependencies").format(item.depends_on.length) }}
                                                            </span>
                                                        </span>
                                                    </v-chip>
                                                    <v-chip
                                                        v-if="item.is_cp"
                                                        class="mx-1"
                                                        small
                                                        color="royal-blue lighten-2"
                                                        style="vertical-align: baseline"
                                                    >
                                                        <span
                                                            class="caption royal-blue--text"
                                                        >
                                                            {{ $t('Client portal').toUpperCase() }}
                                                        </span>
                                                    </v-chip>
                                                </td>
                                                <td class="text-right" @click="edit_task(item)">
                                                    <PersonAvatar
                                                        v-for="(person, index) in get_assignees(item)"
                                                        :key="index"
                                                        :size="24"
                                                        :person="person"
                                                        class-name="mr-1"
                                                    ></PersonAvatar>
                                                    <div v-if="task_group.name === 'once'" class="ml-3 task-table-date">
                                                        <span
                                                            v-if="item.fields && item.fields.workflow_date_rule && (object_type === 'workflow' || object_type === 'project')"
                                                        >
                                                            <v-tooltip v-if="object_type === 'project'" top>
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <span v-on="on">{{ item.fields.workflow_date_rule | format_recurrence_workflow(accountCustomFields) }}</span>
                                                                </template>
                                                                <span>{{ item | format_recurrence_once(false) }}</span>
                                                            </v-tooltip>
                                                            <span v-else>{{ item.fields.workflow_date_rule | format_recurrence_workflow(accountCustomFields) }}</span>
                                                        </span>
                                                        <span v-else>
                                                            {{ item | format_recurrence_once(false) }}
                                                        </span>
                                                    </div>
                                                    <div v-else class="ml-3 task-table-date">
                                                        {{ item.recurrence_rule | format_recurrence(false) }}
                                                    </div>
                                                </td>
                                            </tr>
                                        </template>
                                    </v-data-table>
                                </div>
                            </v-col>
                        </v-row>
                        <DependencyArrows :dependencies="taskDependencies" :relative-elem="relativeDependencyArrows" />
                    </div>

                    <v-row>
                        <v-col v-if="showUpdateChildren" class="mt-2" style="padding-top: 14px;">
                            <v-switch
                                v-model="updateChildren"
                                :label="isEventTypeCompany(account_id) ? $t('Update all events (New tasks)') : $t('Update all projects (New tasks)')"
                                color="primary"
                                class="mt-1 pt-0"
                                hide-details
                            />
                        </v-col>
                        <v-col class="text-right mt-2">
                            <v-btn
                                class="mr-2"
                                text
                                color="primary"
                                @click="close"
                            >
                                {{ cancel_button_text }}
                            </v-btn>
                            <v-btn
                                color="primary"
                                class="inverted--text"
                                :loading="task_save_loading"
                                @click="save_plan()"
                            >
                                {{ save_button_text }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-col>
            </template>
        </v-row>
    </v-col>
</template>

<script>
import Vue from "vue";
import {ref, reactive, computed, watch, onMounted} from "@vue/composition-api";
import { $t } from "@/i18n";
import AppModule from "../../store/modules/app";
import AccountModule from "../../store/modules/account";
import ClientModule from "../../store/modules/client";
import ProjectModule from "../../store/modules/project";
import TaskModule from "../../store/modules/task";
import CustomFieldsModule from "../../store/modules/custom_fields";
import { Router } from "../../composables/Router";
import TaskDialog from "../../views/Task/TaskDialog.vue";
import PersonAvatar from "../../components/PersonAvatar.vue";
import DependencyArrows from "../../components/Task/DependencyArrows";
import { formatNumber, parseSysDate, syncItemChanges } from "../../plugins/formatting";
import ClientPlanReviewChildrenDialog from "./ClientPlanReviewChildrenDialog";
import errorDialog from "@/views/ErrorDialog/errorDialog"
import BreadcrumbsModule from "@/store/modules/breadcrumbs";
import HelpModule from "@/modules/help/help"
import EmailAutomationModule from "@/store/modules/email_automation";
import {formatLanguageLabel} from '@/helpers/formatting'
import FeedbackNotificationModule from "@/store/modules/feedback_notification";
import {useTopicStore} from "../../store/modules/topic";
import {useMemberStore} from "../../store/modules/member";

export default {
    name: "ClientPlanView",
    methods: {formatLanguageLabel},
    components: {
        ClientPlanReviewChildrenDialog,
        TaskDialog,
        PersonAvatar,
        DependencyArrows
    },
    props: {
        is_client_portal: {
            type: Boolean,
            default: false
        },
    },
    setup(props, ctx) {
        const accountModule = AccountModule();
        const { fetchClient, searchClients, setCurrentClient } = ClientModule();
        const { fetchProject, fetchProjects, fetchWorkflowChildren, current_project, clearCache, isEventTypeCompany } = ProjectModule();
        const { saveTaskTemplates, loadTaskTemplates, shiftTaskTemplateStart, newTask, get_task_assigned_names } = TaskModule();
        const { setBreadcrumbs } = BreadcrumbsModule();
        const { emailAutomationTemplates, fetchEmailAutomationTemplates } = EmailAutomationModule()
        const router = Router();
        const {
            fetchClassifiers,
            account_jobs,
            default_jobs,
            default_workflows,
            account_workflows,
            custom_fields,
            handleErrorResponse,
            openTargetBlank,
            toggleSideBar,
            ui_languages,
            isNavigationWarning
        } = AppModule();
        const memberStore = useMemberStore()
        const { showFeedbackNotification } = FeedbackNotificationModule();

        const topicStore = useTopicStore()

        isNavigationWarning.value = true

        const page_title = ref("");
        const save_button_text = ref("");
        const cancel_button_text = ref("");

        const account_id = ref(0);
        const default_person_id = ref(0);
        const default_person = ref({});
        const defaultContactPersonId = ref(null)
        const template_clients = ref([]);
        const all_tasks = ref([]);
        const selected_tasks = ref([]);
        const delete_tasks = [];
        const show_all = ref(true);
        const job_search = ref(null);
        const selected_template_clients = ref([]);
        const current_page = ref(0);
        const total_items = ref(0);
        const task_templates_loaded = ref(false);
        const jobs_templates_loaded = ref(false);
        const task_save_loading = ref(false);
        const object_type = ref(router.currentRoute.meta.type);
        const help_link = ref("");
        const relativeDependencyArrows = ref(null);
        const planExists = ref(false);
        const task_dialog = ref({
            show: false,
            task_id: 0,
            task_ref: null,
            task: null,
            availableRelatedTasks: []
        });
        const review_dialog = ref({ show: false, projects: [], projects_id_list: []});

        const useTemplate = ctx.root.$route.params.use_template === "false" ? 0 : ctx.root.$route.params.use_template;
        const isClientPortal = ref(props.is_client_portal)

        const form_data = reactive({
            name: "",
            locale_code: isClientPortal.value ? accountModule.current_account.value.locale_code : null,
            name_error: null,
            job_source: "",
            job_sources: [],
            client_id: object_type.value === "client" || object_type.value === "job" ? parseInt(router.currentRoute.params.id) : null,
            project_id: object_type.value === "project" || object_type.value === "workflow" ? parseInt(router.currentRoute.params.id) : null,
            object: null,
            task_groups: [
                {
                    name: "once",
                    title: $t("Once"),
                    contains_checked_tasks: false
                },
                {
                    name: "weekly",
                    title: $t("Weekly"),
                    contains_checked_tasks: false
                },
                {
                    name: "monthly",
                    title: $t("Once a month"),
                    contains_checked_tasks: false
                },
                {
                    name: "quarterly",
                    title: $t("Once a quarter"),
                    contains_checked_tasks: false
                },
                {
                    name: "yearly",
                    title: $t("Once a year"),
                    contains_checked_tasks: false
                },
                {
                    name: "finished",
                    title: $t("Finished"),
                    contains_checked_tasks: false
                },
            ],
            jobs: [],
            job_groups: [
                { name: "account_jobs", title: ["workflow", "project"].includes(object_type.value) ? $t("Company workflow") : $t('Company jobs') },
                { name: "default_jobs", title: $t("Default jobs") }
            ],
            highlighted_job_id: 0,
            headers: [
                { text: $t("ID"), value: "id", align: "left", width: "30px" },
                {
                    text: $t("Task title and labels"),
                    value: "title",
                    align: "left"
                },
                {
                    text: $t("Assigned and time"),
                    value: "assigned_and_time",
                    align: "right"
                }
            ],
            tableheaders: true,
            tableactions: true,
            footer_props: {
                "items-per-page-options": [-1]
            },
            page_size: 20
        });
        const updateChildren = ref(true);
        const showUpdateChildren = computed(() => {
            if (object_type.value !== "workflow") return false;
            if (router.currentRoute.params.id === undefined) return false;
            if (useTemplate) return false;
            return true;
        });

        const prepare_job_data = function(job, tasks, job_group) {
            let job_data = {
                id: job.id,
                selected: false,
                type: job_group,
                name: job.name,
                task_id_list: job.tasks.map(x => x.id),
                task_count: job.tasks.length
            };

            for (let j in job.tasks) {
                tasks.push(prepare_task_data(job.tasks[j], job.id, false));
            }

            return job_data;
        };
        const prepare_template_object = (template_object) => {
            return {
                id: template_object.id,
                selected: selected_template_clients.value.indexOf(template_object.id) >= 0,
                name: template_object.name
            };
        };
        const prepare_task_data = function(task, job_id, selected, set_base_id = true, idMap = null) {
            let t = Vue.clone_object(task);
            if ((useTemplate || ctx.root._route.query.clone_id) && idMap != null) {
                t.id = idMap[t.id];
                t.virtual_id = 0;
                t.depends_on = t.depends_on.map(x => idMap[x]);
                t.status = 'new';
            }
            t.job_id = job_id;
            t.selected = selected;
            if (set_base_id) t.base_task_id = t.id;
            if (t.fields != null && t.fields.assignees_by_field !== undefined && t.fields.assignees_by_field.length > 0)
                t.assignees = t.assignees.concat(t.fields.assignees_by_field);
            if (object_type.value === "project")
                t.project = form_data.object;
            return t;
        };
        const sync_current_tasks_and_jobs = function() {
            if (!task_templates_loaded.value || !jobs_templates_loaded.value)
                return;

            let base_task_id_list = [];
            let selected_job_task_id_list = [];

            for (let i in selected_tasks.value) {
                if (selected_tasks.value[i].base_task_id == null) continue;

                let base_task_id = selected_tasks.value[i].base_task_id;
                base_task_id_list.push(base_task_id);

                for (let j in form_data.jobs) {
                    if (form_data.jobs[j].task_id_list.indexOf(base_task_id) >= 0) {
                        if (!form_data.jobs[j].selected) {
                            selected_job_task_id_list = selected_job_task_id_list.concat(
                                form_data.jobs[j].task_id_list
                            );
                            form_data.jobs[j].selected = true;
                        }

                        selected_tasks.value[i].job_id = form_data.jobs[j].id;
                        break;
                    }
                }
            }

            let show_unselected_task_id_list = selected_job_task_id_list.filter(
                x => base_task_id_list.indexOf(x) === -1
            );
            let idMap = generate_id_map(all_tasks.value);
            for (let i = 0; i < all_tasks.value.length; i++) {
                if (show_unselected_task_id_list.indexOf(all_tasks.value[i].id) >= 0) {
                    selected_tasks.value.push(
                        set_task_object_data(all_tasks.value[i], false, idMap)
                    );
                }
            }
        };

        const set_task_base_data = (task, selected, idMap = null) => {
            task.selected = selected;
            task.id = idMap != null ? idMap[task.id] : 0;
            task.virtual_id = 0;
            task.account_id = account_id.value;
            task.depends_on = task.depends_on.map(x => idMap[x]);

            if (task.automations && form_data.client && form_data.client.locale_code) {
                for (let automationIndex in task.automations) {
                    let automation = task.automations[automationIndex];

                    if (!automation.content_template_id) {
                        continue
                    }

                    const template = emailAutomationTemplates.value.find(x => x.id === automation.content_template_id);

                    if (!template) {
                        continue
                    }

                    const templateRow = template.rows.find(x => x.locale_code === form_data.client.locale_code)
                    if (templateRow) {
                        task.automations[automationIndex].locale_code = templateRow.locale_code
                    }
                }
            }
        }
        const set_task_client_data = (task, selected, idMap = null) => {
            set_task_base_data(task, selected, idMap);
            let object_id = parseInt(router.currentRoute.params.id);
            //if (task.client_id !== object_id) {
            if (object_type.value === "workflow") {
                task.project_id = object_id;
            }
            else if (object_type.value === "job" || object_type.value === 'client') {
                task.client_id = object_id;
            }

            if (object_type.value === "job") {
                task.assignees = [];
                task.assignees_data = [];
            }
            else if (object_type.value === "workflow") {
                // task.assignees = [];
                // task.assignees_data = [];
            }
            else {
                task.assignees = [default_person_id.value];
                task.assignees_data = [
                    {
                        assigned_id: default_person_id.value,
                        assigned_name: default_person.value.name,
                        assigned_surname: default_person.value.surname,
                        assigned_initials: default_person.value.initials,
                        assigned_full_name: "{0} {1}"
                            .format(
                                default_person.value.name,
                                default_person.value.surname
                            )
                            .trim(),
                        assigned_avatar: default_person.value.avatar
                    }
                ];

                if (task.is_cp) {
                    if (defaultContactPersonId.value) {
                        task.cp_assignees = [defaultContactPersonId.value]
                    } else {
                        task.cp_auto_finish = 0
                    }
                }
            }
            //}
            if (task.recurrence_rule == null) {
                if (task.due_date == null) {
                    let d = new Date();
                    d.setHours(8, 0, 0, 0);
                    task.date = d.formatSysDateTime();
                    d.setHours(23, 59, 59, 0);
                    task.due_date = d.formatSysDateTime();
                } else {
                    let d = parseSysDate(task.date).thisMonth();
                    let dd = parseSysDate(task.due_date).thisMonth();
                    d.setHours(8, 0, 0, 0);
                    dd.setHours(23, 59, 59, 0);
                    task.date = d.formatSysDateTime();
                    task.due_date = dd.formatSysDateTime();
                }
            }
            return task;
        };
        const set_task_project_data = (task, selected, idMap = null) => {
            set_task_base_data(task, selected, idMap);

            if (object_type.value === "workflow") {
                // task.assignees = [];
                // task.assignees_data = [];
            }
            else if (object_type.value === "project") {
                task.project_id = form_data.object.id;
                task.client_id = form_data.object.client_id

                if (task.fields != null && task.fields.assignees_by_field !== undefined) {
                    for (let field_name of task.fields.assignees_by_field) {
                        let val = form_data.object[field_name];
                        if (!val) continue;
                        if (!Array.isArray(val))
                            val = [val];
                        for (let member_id of val) {
                            if (task.assignees.indexOf(member_id) === -1)
                                task.assignees.push(member_id);
                        }
                    }
                }

                if (task.is_cp) {
                    if (defaultContactPersonId.value) {
                        task.cp_assignees = [defaultContactPersonId.value]
                    } else {
                        task.cp_auto_finish = 0
                    }
                }
            }

            if (task.fields != null && task.fields.workflow_date_rule !== undefined) {
                calcWorkflowTaskDates(task);
            }

            return task;
        };
        const set_task_object_data =
            object_type.value === "project" || object_type.value === "workflow" ?
                set_task_project_data : set_task_client_data;

        const loadClassifiers = async () => {
            let types = ["custom_fields"];
            let force_types = [];
            let templateGroups = {};
            if (object_type.value === "job" || object_type.value === "client") {
                types.push("default_jobs");
                types.push("account_jobs");
                force_types.push("account_jobs");
                templateGroups["account"] = account_jobs;
                templateGroups["default"] = default_jobs;
            }
            if (object_type.value === "workflow" || object_type.value === "project") {
                types.push("account_workflows");
                force_types.push("account_workflows");
                // todo :: load and show Uku Demo master workflows
                force_types.push("default_workflows");
                templateGroups["account"] = account_workflows;
                templateGroups["default"] = default_workflows
            }
            try {
                await fetchClassifiers({
                    types,
                    account_id: account_id.value,
                    force: {default: true, types: force_types},
                    is_client_portal: isClientPortal.value
                })

                let jobs = [];
                let tasks = [];

                for (let prop in templateGroups) {
                    if (Object.prototype.hasOwnProperty.call(templateGroups, prop)) {
                        if (templateGroups[prop].value[account_id.value] !== undefined) {
                            for (let template of templateGroups[prop].value[account_id.value]) {
                                jobs.push(prepare_job_data(template, tasks, prop));
                            }
                        }
                    }
                }
                form_data.jobs = jobs;

                all_tasks.value = tasks;
                jobs_templates_loaded.value = true;

                sync_current_tasks_and_jobs();

                if (object_type.value === "workflow" || object_type.value === "project") {
                    form_data.job_sources[1].title = isEventTypeCompany(account_id.value) ? $t('Events') : $t('Projects')

                    if (object_type.value === "project") {
                        const text = isEventTypeCompany(account_id.value) ? $t("Setup tasks for {0} event") : $t("Setup tasks for {0} project")
                        page_title.value = text.format(
                            '<span style="font-weight: 700">' + form_data.object.name + "</span>"
                        );
                    }
                }

                switch (ctx.root._route.name) {
                    case "job_new":
                    case "job_edit":
                        help_link.value = HelpModule.getHelpLink("add_template");
                        break;
                    case "workflow_new":
                    case "workflow_edit":
                        help_link.value = HelpModule.getHelpLink("add_workflow");
                        break;
                    default:
                        help_link.value = HelpModule.getHelpLink("edit_plan");
                        break;
                }

            } catch (e) {
                errorDialog.showError(e)
            }
        };
        const load_task_templates = () => {
            let object_id = parseInt(ctx.root._route.query.clone_id ? ctx.root._route.query.clone_id : router.currentRoute.params.id);
            loadTaskTemplates(object_type.value, object_id)
                .then(resp => {
                    let idMap = generate_id_map(resp);
                    /*if (object_type.value !== "project" && object_type.value !== "workflow") {
                        for (let i = 0; i < resp.length; i++) {
                            shiftTaskTemplateStart(resp[i]);
                        }
                    }*/
                    selected_tasks.value = resp.map(
                        x => prepare_task_data(x, null, get_default_task_selection(x), false, idMap)
                    );

                    if (selected_tasks.value.length) {
                        planExists.value = true
                    }

                    task_templates_loaded.value = true;
                    sync_current_tasks_and_jobs();
                })
                .catch(ex => errorDialog.showError(ex));
        };
        const get_default_task_selection = (task) => {
            if (object_type.value === "project") {
                if (router.currentRoute.params.action === "cancel") {
                    if (task.status === "new" || task.status === "in_progress")
                        return false
                }
            }
            return true;
        }

        const load_job = async function() {
            page_title.value = router.currentRoute.params.id === undefined ? $t("New job") : $t("Edit job");
            save_button_text.value = $t("Save");
            cancel_button_text.value = $t("Cancel");

            if (router.currentRoute.params.id === undefined) {
                task_templates_loaded.value = true;
            }
            else {
                try{
                    const resp = await fetchClient({ client_id: parseInt(router.currentRoute.params.id), for_edit: 1 })
                    form_data.name = useTemplate ? "" : resp.name;
                    form_data.locale_code = resp.locale_code
                    isClientPortal.value = resp && resp._data ? resp._data.is_cp_plan : false
                } catch (ex) {
                    errorDialog.showError(ex)
                }
                load_task_templates();
            }
        };
        const load_workflow = () => {
            page_title.value = router.currentRoute.params.id === undefined ? $t("New workflow") : $t("Edit workflow");
            save_button_text.value = $t("Save workflow");
            cancel_button_text.value = $t("Cancel");

            if (router.currentRoute.params.id === undefined) {
                task_templates_loaded.value = true;
            }
            else {
                fetchProject(parseInt(router.currentRoute.params.id))
                    .then(() => {
                        form_data.name = useTemplate ?
                            $t("{0} (Copy)").format(current_project.value.name) : current_project.value.name;
                    })
                    .catch(ex => errorDialog.showError(ex));

                load_task_templates();
            }
        };
        const loadClient = async () => {
            save_button_text.value = $t("Confirm task plan");
            cancel_button_text.value = $t("Skip");

            let client_id = parseInt(router.currentRoute.params.id);
            try {
                const resp = await fetchClient({
                    client_id,
                    include_default_person: 1,
                    for_edit: 0
                })
                setCurrentClient(resp)

                account_id.value = resp.account_id;
                form_data.client = {
                    id: client_id,
                    name: resp.name,
                    client_initials: resp.client_initials,
                    color: resp.color,
                    ext_client_id: resp.ext_client_id,
                    locale_code: resp.locale_code
                };

                if (resp.default_person_id) {
                    default_person_id.value = resp.default_person_id;
                    default_person.value = resp.default_person;
                }
                else {
                    let owner = accountModule.map.value
                        .get(account_id.value)
                        .members.find(x => x.role === "owner");
                    default_person_id.value = owner.id;
                    default_person.value = owner;
                }

                if (resp.contacts) {
                    const defaultContact = resp.contacts.find(x => x.is_primary)
                    if (defaultContact) {
                        defaultContactPersonId.value = defaultContact.person_id
                    }
                }

                load_task_templates();
                await loadClassifiers();
                setViewBreadcrumbs();
                page_title.value = task_groups.value.length === 0 ? $t("Create task plan") : $t("Edit task plan")
            } catch (ex) {
                errorDialog.showError(ex);
            }

        };
        const loadProject = async () => {
            save_button_text.value = $t("Confirm workflow");
            cancel_button_text.value = $t("Skip");

            try {
                let project_id = parseInt(router.currentRoute.params.id);
                const forEdit = true
                const loadDefaultClientContact = true
                const resp = await fetchProject(project_id, forEdit, loadDefaultClientContact)

                if (resp.default_client_contact_person_id) {
                    defaultContactPersonId.value = resp.default_client_contact_person_id
                }

                account_id.value = resp.account_id;
                form_data.object = resp;
                load_task_templates();
                loadClassifiers();
            } catch (ex) {
                errorDialog.showError(ex)
            }

        };
        const getSearchParams = (search_name, page) => {
            return {
                keyword: search_name == null ? "" : search_name,
                columns: ["id", "name"],
                page: page,
                itemsPerPage: form_data.page_size,
                account_id: account_id.value,
                sortBy: "name",
                sortDesc: false
            };
        };
        const load_template_clients = (search_name, page) => {
            searchClients(getSearchParams(search_name, page))
                .then(resp => {
                    if (search_name === job_search.value) {
                        template_clients.value = resp.clients.map(x => prepare_template_object(x));
                        current_page.value = page;
                        total_items.value = resp.total;
                    }
                })
                .catch(ex => errorDialog.showError(ex));
        };
        const load_template_projects = (search_name, page) => {
            fetchProjects(getSearchParams(search_name, page))
                .then(resp => {
                    if (search_name === job_search.value) {
                        template_clients.value = resp.items.map(x => prepare_template_object(x));
                        current_page.value = page;
                        total_items.value = resp.total_items;
                    }
                })
                .catch(ex => errorDialog.showError(ex));
        };
        const load_template_objects = object_type.value === "project" || object_type.value === "workflow" ? load_template_projects : load_template_clients;
        const load_and_add_template_object_tasks = template_object_id => {
            loadTaskTemplates(object_type.value, template_object_id)
                .then(resp => {
                    let idMap = generate_id_map(resp);
                    for (let t of resp) {
                        let task = prepare_task_data(t, template_object_id, true, false, idMap);
                        selected_tasks.value.push(set_task_object_data(task, !planExists.value, idMap));
                    }
                })
                .catch(ex => errorDialog.showError(ex));
        };
        const loadData = async () => {
            setSources();

            if (object_type.value === "job") {
                account_id.value = parseInt(router.currentRoute.params.account_id);
                await loadClassifiers();
                await load_job();
            }
            else if (object_type.value === "workflow") {
                account_id.value = parseInt(router.currentRoute.params.account_id);
                await loadClassifiers();
                load_workflow();
            }
            else if (object_type.value === "project") {
                await loadProject();
            }
            else if (object_type.value === "client") {
                await loadClient();
            }

            const defaultWorkflowOrJobId = parseInt(router.currentRoute.query.default_workflow_or_job_id)
            if (defaultWorkflowOrJobId) {
                const defaultWorkflowOrJob = jobs.value.find(x => x.id === defaultWorkflowOrJobId)
                if (defaultWorkflowOrJob) {
                    defaultWorkflowOrJob.selected = true
                    job_change(null, defaultWorkflowOrJob)
                }
            }

            if (account_id.value) {
                fetchEmailAutomationTemplates(account_id.value);
            }
        };
        const setSources = () => {
            if (object_type.value === "job" || object_type.value === "client") {
                if(isClientPortal.value) {
                    form_data.job_sources = [
                        { name: "jobs", title: $t("Client portal templates") },
                    ]
                } else {
                    form_data.job_sources = [
                        { name: "jobs", title: $t("Jobs") },
                        { name: "clients", title: $t("Clients") }
                    ];
                }
                form_data.job_source = "jobs";
            }
            else if (object_type.value === "workflow" || object_type.value === "project") {
                form_data.job_sources = [
                    { name: "workflows", title: $t("Workflows") },
                    { name: "projects", title: $t("Projects") }
                ];
                form_data.job_source = "workflows";
            }
        }

        const jobs = computed(function() {
            let ret = [];
            let search_name = job_search.value
                ? job_search.value.toLowerCase()
                : null;

            let account_jobs = form_data.jobs.filter(
                x =>
                    x.type === "account" &&
                    (search_name == null ||
                        x.name.toLowerCase().indexOf(search_name) >= 0)
            );
            if (account_jobs.length > 0) {
                ret.push({ title: ["workflow", "project"].includes(object_type.value) ? $t("Company workflows") : $t('Company jobs'), type: "sub-header" });
                ret = ret.concat(account_jobs);
            }

            let default_jobs = isClientPortal.value ? [] : form_data.jobs.filter(
                x =>
                    x.type === "default" &&
                    (search_name == null ||
                        x.name.toLowerCase().indexOf(search_name) >= 0)
            );
            if (default_jobs.length > 0) {
                ret.push({ title: ["workflow", "project"].includes(object_type.value) ? $t("Default workflows") : $t('Default jobs'), type: "sub-header" });
                ret = ret.concat(default_jobs);
            }
            return ret;
        });
        const tasks = computed(function() {
            let ret = {
                once: [],
                weekly: [],
                monthly: [],
                quarterly: [],
                yearly: [],
                finished: []
            };
            let once = [];

            for (let i in selected_tasks.value) {
                if (selected_tasks.value[i].recurrence_rule == null) {
                    once.push(selected_tasks.value[i]);
                }
                else {
                    let isFinished = false
                    const recurrenceEndsDateString = selected_tasks.value[i].recurrence_rule && selected_tasks.value[i].recurrence_rule.recurrence_ends_date
                    if (recurrenceEndsDateString) {
                        const recurrenceEndsDate = parseSysDate(recurrenceEndsDateString)
                        isFinished = recurrenceEndsDate < new Date()
                    }

                    if (isFinished) {
                        ret['finished'].push(selected_tasks.value[i]);
                    } else {
                        let recurrence_rule = selected_tasks.value[i].recurrence_rule.type;
                        let key = recurrence_rule === "wf_date" ? "once" : recurrence_rule;
                        ret[key].push(selected_tasks.value[i]);
                    }
                }
            }

            if (object_type.value === "workflow")
                ret.once = once.sort(sort_tasks_workflow);
            else if (object_type.value === "project")
                ret.once = once.sort(sort_tasks_project);
            else
                ret.once = once;

            return ret;
        });
        const task_groups = computed(function() {
            let ret = [];

            for (let task_group of form_data.task_groups) {
                if (tasks.value[task_group.name].length > 0) {
                    task_group.contains_checked_tasks = tasks.value[task_group.name].filter(x => x.selected).length > 0;
                    ret.push(task_group);
                }
            }

            return ret;
        });
        const all_checked = computed({
            get: function() {
                for (let i in selected_tasks.value) {
                    if (!selected_tasks.value[i].selected) return false;
                }
                return true;
            },
            set: function(val) {
                for (let i in selected_tasks.value) {
                    if (selected_tasks.value[i].selected !== val)
                        selected_tasks.value[i].selected = val;
                }
            }
        });
        const selected_count = computed(function() {
            return selected_tasks.value.filter(x => x.selected).length;
        });
        const total_pages = computed(function() {
            return Math.ceil(total_items.value / form_data.page_size);
        });
        const page_info = computed(function() {
            let show_from = (current_page.value - 1) * form_data.page_size + 1;
            let show_until = current_page.value * form_data.page_size;
            if (show_until > total_items.value) show_until = total_items.value;
            return $t("{0}-{1} of {2}").format(
                formatNumber(show_from),
                formatNumber(show_until),
                formatNumber(total_items.value)
            );
        });
        const counter = ref(0);
        const taskDependencies = computed(() => {
            let ret = [];
            for (let t of selected_tasks.value) {
                if (!t.depends_on) continue;
                for (let depends_on_id of t.depends_on) {
                    ret.push([t.id, depends_on_id]);
                }
            }
            return ret;
        });
        const accountCustomFields = computed(() => {
            if (custom_fields.value[account_id.value] === undefined) return [];
            return custom_fields.value[account_id.value];
        });
        const projectDateFields = computed(() => {
            if (object_type.value !== "workflow" && object_type.value !== "project") return [];
            if (custom_fields.value[account_id.value] === undefined) return [];
            return custom_fields.value[account_id.value]
                .filter(x => x.type === "date")
                .filter(x => x.related_type.startsWith("project."))
                .map(x => x.name);
        });
        const pseudoUsers = computed(() => {
            if (object_type.value !== "workflow") return [];
            if (custom_fields.value[account_id.value] === undefined) return [];
            return custom_fields.value[account_id.value]
                .filter(x => x.related_type.startsWith("project.") && (x.type === "user_single" || x.type === "user_multi"))
                .map(x => ({
                    account_id: account_id.value,
                    avatar: null,
                    id: x.name,
                    initials: x.title.trim().charAt(0).toUpperCase(),
                    name: x.title,
                    status: "active",
                    type: "field"
                }));
        });

        watch (() => task_dialog.value.show, () => {
            if (task_dialog.value.show) {
                return
            }

            for (var task of selected_tasks.value) {
                const recurrence_rule_type = task.recurrence_rule ? task.recurrence_rule['type'] : null

                if (!task.depends_on) {
                    continue;
                }

                task.depends_on = task.depends_on.filter(depends_on_id => {
                    const x = selected_tasks.value.find(x => x.id === depends_on_id);

                    if (!x) {
                        return false;
                    }

                    if (recurrence_rule_type === 'weekly') {
                        const main_task_max_week = Math.max(task.recurrence_rule['weekdays'])
                        const depends_on_task_max_week = Math.max(x.recurrence_rule['weekdays'])

                        if (main_task_max_week < depends_on_task_max_week) {
                            return false
                        }
                    } else if (recurrence_rule_type === 'monthly') {
                        const main_task_day_of_month = task.recurrence_rule['day_of_month']
                        const depends_on_task_day_of_month = x.recurrence_rule['day_of_month']

                        if (main_task_day_of_month < depends_on_task_day_of_month) {
                            return false
                        }
                    } else if (recurrence_rule_type === 'quarterly') {
                        const main_task_monthly_period = task.recurrence_rule['month_of_period']
                        const main_task_day_period = task.recurrence_rule['day_of_month']

                        const depends_on_task_monthly_period = x.recurrence_rule['month_of_period']
                        const depends_on_task_day_period = x.recurrence_rule['day_of_month']

                        if (main_task_monthly_period < depends_on_task_monthly_period) {
                            return false
                        } else if ((main_task_monthly_period === depends_on_task_monthly_period) && (main_task_day_period < depends_on_task_day_period)) {
                            return false
                        }
                    } else if (recurrence_rule_type === 'yearly') {
                        const main_task_monthly_period = task.recurrence_rule['month_of_period']
                        const main_task_day_period = task.recurrence_rule['day_of_month']

                        const depends_on_task_monthly_period = x.recurrence_rule['month_of_period']
                        const depends_on_task_day_period = x.recurrence_rule['day_of_month']

                        if (main_task_monthly_period < depends_on_task_monthly_period) {
                            return false
                        } else if ((main_task_monthly_period === depends_on_task_monthly_period) && (main_task_day_period < depends_on_task_day_period)) {
                            return false
                        }
                    }

                    return true
                })
            }
        }, { immediate: true })

        watch (job_search, search_name => {
            if (form_data.job_source === "clients" || form_data.job_source === "projects") {
                setTimeout(() => {
                    if (search_name === job_search.value) {
                        load_template_objects(search_name, 1);
                    }
                }, 200);
            }
        }, { immediate: true });

        const get_sort_score = a => {
            let score = 0;
            if (a.fields != null && a.fields.workflow_date_rule !== undefined) {
                let rule = a.fields.workflow_date_rule;
                if (rule.date_field)
                    score = (projectDateFields.value.indexOf(rule.date_field) + 2) * 1000;
                score += rule.count_days * (rule.date_dir === "before" ? -1 : 1);
            }
            return score;
        }
        const sort_tasks_workflow = (a, b) => {
            let a_score = get_sort_score(a);
            let b_score = get_sort_score(b);
            if (a_score < b_score) return -1;
            if (a_score > b_score) return 1;
            return a.title.localeCompare(b.title, undefined, {numeric: true});
        }
        const sort_tasks_project = (a, b) => {
            if (a.date < b.date) return -1;
            if (a.date > b.date) return 1;
            return a.title.localeCompare(b.title, undefined, {numeric: true})
        }
        const add_task = (new_task = null) => {
            if(new_task === null) {
                new_task = newTask(
                    account_id.value,
                    null,
                    null,
                    null,
                    true,
                    object_type.value
                );
            }

            new_task.selected = true;

            let object_id = parseInt(router.currentRoute.params.id);
            if (object_id) {
                if (object_type.value === "workflow" || object_type.value === "project") {
                    new_task.project_id = object_id;
                    if (object_type.value === "project") {
                        new_task.client_id = form_data.object.client_id;
                        new_task.project = form_data.object;
                    }
                }
                else {
                    new_task.client_id = object_id;
                }
            }

            task_dialog.value.task_id = 0;
            task_dialog.value.task_ref = null;
            task_dialog.value.task = new_task;
            task_dialog.value.task.client = form_data.client;
            task_dialog.value.availableRelatedTasks = get_available_related_tasks();
            task_dialog.value.show = true;
        };
        const edit_task = function(item) {
            task_dialog.value.task_id = item.id;
            task_dialog.value.task_ref = item;
            task_dialog.value.task = Vue.clone_object(item);
            task_dialog.value.task.client = form_data.client;
            task_dialog.value.availableRelatedTasks = get_available_related_tasks();
            task_dialog.value.show = true;
        };
        const get_available_related_tasks = () => {
            return selected_tasks.value;
        };
        const calcWorkflowTaskDates = task => {
            if (object_type.value !== "project")  // workflow dates are calculated only for project
                return;

            let date_rule = task.fields.workflow_date_rule;
            let val = form_data.object[date_rule.date_field];
            if (!val) return;

            let d = parseSysDate(val).calcAddDays(
                date_rule.count_days * (date_rule.date_dir === "before" ? -1 : 1)
            );
            d.setHours(8, 0, 0, 0);
            task.date = d.formatSysDateTime();
            if (date_rule.has_due_date && date_rule.due_count_days) {
                d = d.calcAddDays(date_rule.due_count_days);
            }
            d.setHours(23, 59, 59, 0);
            task.due_date = d.formatSysDateTime();
        };
        const save_task = () => {
            let task = Vue.clone_object(task_dialog.value.task);
            if (task.fields != null && task.fields.workflow_date_rule !== undefined) {
                calcWorkflowTaskDates(task);
            }

            if (task_dialog.value.task_ref != null) {
                syncItemChanges(task_dialog.value.task_ref, task);
            }
            else {
                if (!task.id) {
                    counter.value++;
                    task.id = "tmp{0}".format(counter.value);
                }
                selected_tasks.value.push(task);
            }
            close_task_dialog();
        };
        const close_task_dialog = function(params) {
            if(params && params.action === 'create_recurring') {
                let new_task = newTask(
                    params.task_data.account_id,
                    params.task_data.client_id,
                    params.task_data.title,
                    params.task_data.topic_id,
                    true,
                    object_type.value
                );
                add_task(new_task)
                return
            }
            task_dialog.value.show = false;
            task_dialog.value.task = null;
            task_dialog.value.task_ref = null;
            task_dialog.value.task_id = 0;
            task_dialog.value.availableRelatedTasks = [];
        };

        const job_source_changed = (() => {
            if (object_type.value === "workflow" || object_type.value === "project") {
                return () => {
                    if (form_data.job_source === "projects" && current_page.value === 0)
                        load_template_projects(job_search.value, 1);
                };
            }
            else {
                return () => {
                    if (form_data.job_source === "clients" && current_page.value === 0)
                        load_template_clients(job_search.value, 1);
                };
            }
        })();
        const set_page = function(page) {
            load_template_objects(job_search.value, page);
        };
        const job_select = (e, job) => {
            form_data.highlighted_job_id = job.id;
        };
        const template_client_select = function(e, template_client) {
            form_data.highlighted_job_id = template_client.id;
        };
        const generate_id_map = tasks => {
            let ret = [];
            for (let t of tasks) {
                counter.value++;
                ret[t.id] = "tmp{0}".format(counter.value);
            }
            return ret;
        }
        const job_change = (e, job) => {
            if (job.selected) {
                let template_tasks = all_tasks.value.filter(x => x.job_id === job.id);
                let idMap = generate_id_map(template_tasks);
                for (let tt of template_tasks) {
                    selected_tasks.value.push(set_task_object_data(tt, !planExists.value, idMap));
                }
            }
            else {
                for (let j = selected_tasks.value.length - 1; j >= 0; j--) {
                    if (selected_tasks.value[j].job_id === job.id) {
                        let task = selected_tasks.value[j];
                        if (!delete_tasks.find(x => x.id === task)) {
                            delete_tasks.push(task);
                        }
                        selected_tasks.value.splice(j, 1);
                    }
                }
            }
        };
        const template_object_change = (e, template_object) => {
            if (template_object.selected) {
                selected_template_clients.value.push(template_object.id);

                load_and_add_template_object_tasks(template_object.id);
            }
            else {
                let tmpIdx = selected_template_clients.value.indexOf(template_object.id);
                if (tmpIdx >= 0) {
                    selected_template_clients.value.splice(tmpIdx, 1);
                }

                for (let j = selected_tasks.value.length - 1; j >= 0; j--) {
                    if (selected_tasks.value[j].job_id === template_object.id) {
                        selected_tasks.value.splice(j, 1);
                    }
                }
            }
        };
        const task_change = function() {};
        const show_hide_others = function() {
            show_all.value = !show_all.value;
        };
        const save_plan = (confirmed = false) => {
            task_save_loading.value = true;

            if (object_type.value === "workflow" && updateChildren.value && !confirmed) {
                reviewChildren();
                return;
            }

            let object_id = router.currentRoute.params.id === undefined ? 0 : parseInt(router.currentRoute.params.id);
            let data_list = {
                id: useTemplate ? 0 : object_id,
                type: object_type.value,
                tasks: [],
                jobs: []
            };
            if (object_type.value === "workflow") {
                data_list['projects_id_list'] = review_dialog.value.projects_id_list;
            }
            if (object_type.value === "job" || object_type.value === "workflow") {
                data_list["account_id"] = account_id.value;
                data_list["name"] = form_data.name;
                if(isClientPortal.value) {
                    data_list["locale_code"] = form_data.locale_code
                    if(!data_list['id']) data_list['is_cp_plan'] = 1
                }
            }

            let tmp_custom_fields = [];

            for (let i in selected_tasks.value) {
                let task = Vue.clean_and_clone_object(selected_tasks.value[i]);

                if (!task.selected && task.id === 0) continue;
                task.is_deleted = !task.selected;
                if (object_type.value === "workflow" || object_type.value === "project")
                    task.project_id = data_list.id;
                else
                    task.client_id = data_list.id;

                data_list["tasks"].push(task);

                if (task.job_id && data_list.jobs.indexOf(task.job_id) === -1)
                    data_list.jobs.push(task.job_id);

                if (task.fields != null) {
                    for (let prop in task.fields) {
                        if (prop === "assignees_by_field" || prop === "workflow_date_rule") continue;
                        if (Object.prototype.hasOwnProperty.call(task.fields, prop)) {
                            if (tmp_custom_fields.indexOf(prop) === -1)
                                tmp_custom_fields.push(prop);
                        }
                    }
                }
            }

            for (let deleteTask of delete_tasks) {
                deleteTask.is_deleted = true;
                data_list["tasks"].push(deleteTask)
            }

            saveTaskTemplates(data_list)
                .then(() => {
                    fetchClassifiers({
                        types: ["account_job_names"],
                        account_id: account_id.value,
                        include_inactive_account: 1
                    }).catch(ex => errorDialog.showError(ex));

                    if (["workflow", "job"].includes(object_type.value)) {
                        let text = data_list.id ? $t('Company template saved') : $t('Company template created')
                        showFeedbackNotification(text)
                    }

                    clearCache();
                    close();
                    task_save_loading.value = false;
                })
                .catch(ex => {
                    handleErrorResponse(form_data, ex);
                    task_save_loading.value = false;
                });
        };
        const reviewChildren = () => {
            if (useTemplate || router.currentRoute.params.id === undefined) {
                review_dialog.value.projects_id_list = [];
                save_plan(true);
                return;
            }

            fetchWorkflowChildren(account_id.value, parseInt(router.currentRoute.params.id))
                .then(resp => {
                    if (resp.items.length > 0) {
                        review_dialog.value.projects = resp.items;
                        review_dialog.value.show = true;
                        task_save_loading.value = false;
                    }
                    else {
                        review_dialog.value.projects_id_list = [];
                        save_plan(true);
                    }
                })
                .catch(ex => errorDialog.showError(ex));
        }
        const save_plan_confirmed = (projects_id_list) => {
            review_dialog.value.show = false;
            review_dialog.value.projects_id_list = projects_id_list;
            save_plan(true);
        }
        const close_review_dialog = () => {
            review_dialog.value.show = false;
        }

        const get_topic_name = function(topic_id) {
            const topic = topicStore.getTopicById(topic_id)
            return topic ? topic.name : null
        };
        const get_assignees = item => {
            let ret = item.assignees.map(x => {
                if (Number.isInteger(x)) return memberStore.getMemberById(x);
                else return pseudoUsers.value.find(y => y.id === x);
            }).filter(x => x != null);

            return ret;
        };
        const change_source = function(src) {
            form_data.job_source = src;
            job_source_changed();
        };

        const close = () => {
            isNavigationWarning.value = false

            switch (object_type.value) {
                case "job":
                case "workflow":
                    router.push({
                        name: "app_store",
                        params: { accountId: account_id.value }
                    });
                    break;
                case "client":
                    router.push({
                        name: "client_profile_plan",
                        params: { id: parseInt(router.currentRoute.params.id) }
                    });
                    break;
                case "project":
                    router.push({
                        name: "project_view",
                        params: { id: parseInt(router.currentRoute.params.id) }
                    });
                    break;
                default:
                    router.push({ name: "dashboard" });
                    break;
            }
        };
        const goto_client_plan = function() {
            router.push({
                name: "client_profile_plan",
                params: { id: parseInt(router.currentRoute.params.id) }
            });
        };
        const getTaskTitle = task_id => {
            let t = selected_tasks.value.find(x => x.id === task_id);
            return t == null ? $t("Unknown") : t.title;
        }
        const rowMouseOver = (itemId, over) => {
            let elCol = document.getElementsByClassName("dep-arrow-{0}".format(itemId));
            for (let el of elCol) {
                el.style.display = over ? "block" : "none";
            }
        }

        const removeDeletedTask = (id) => {
            selected_tasks.value = selected_tasks.value.filter(x => x.id !== id)
        }

        const setViewBreadcrumbs = () => {
            if (form_data.client) {
                setBreadcrumbs([
                    {
                        to: {
                            name: 'clients_list',
                        },
                        name: $t('Clients')
                    },
                    {
                        to: {
                            name: 'client_profile_overview',
                            params: {
                                id: form_data.client.id,
                            }
                        },
                        name: form_data.client.name
                    }
                ], ctx.root._route.name)
            }
        }

        loadData();

        return {
            page_title,
            save_button_text,
            cancel_button_text,
            form_data,
            jobs,
            template_clients,
            task_groups,
            tasks,
            all_checked,
            selected_count,
            show_all,
            job_search,
            current_page,
            total_pages,
            page_info,
            task_templates_loaded,
            jobs_templates_loaded,
            task_save_loading,
            object_type,
            help_link,
            task_dialog,
            taskDependencies,
            pseudoUsers,
            accountCustomFields,
            job_source_changed,
            showUpdateChildren,
            updateChildren,
            review_dialog,
            set_page,
            add_task,
            edit_task,
            job_select,
            job_change,
            template_client_select,
            template_object_change,
            task_change,
            show_hide_others,
            save_plan,
            close,
            change_source,
            goto_client_plan,
            close_task_dialog,
            save_task,
            get_topic_name,
            get_assignees,
            getTaskTitle,
            rowMouseOver,
            toggleSideBar,
            get_task_assigned_names,
            open_help: openTargetBlank,
            save_plan_confirmed,
            close_review_dialog,
            removeDeletedTask,
            relativeDependencyArrows,
            isClientPortal,
            ui_languages,
            default_workflows,
            account_id,
            isEventTypeCompany,
            planExists
        };
    }
};
</script>
